module.exports = __webpack_public_path__ + "img/icon-activity-news-active-old.7b69dd6d.svg";